<template>
    <div class="store__gallon-water">
        <h1 class="store-headline">Customize Water Plan</h1>
    
        <div class="row">
            <div class="col-lg-3 offer" v-if="this.offer">
                <label for="offer">
                    <img :src="pluginUrl + '/assets/img/money-circle.svg'" alt="" class="icon" aria-hidden="true">
                    {{ offerName }}*
                </label>

                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" v-model="offerSelected" id="offerSelected" value="1">
                    <label class="custom-control-label" for="offerSelected"></label>
                </div>
                <small class="offer__disclaimer">*Eligible on recurring deliveries only</small>
            </div>
            
            <div class="water-bottles" v-bind:class="{ 'col-lg-5': this.offer, 'col-lg-6': !this.offer }">
                <h3>Choose Water & Number of Bottles</h3>
                
                <div class="water-bottles__options">
                    <div class="water-bottles__option">
                        <span class="option__name">{{ product.name }}</span>
                        
                        <img v-bind:src="product.image" v-bind:alt="product.name">
                        
                        <div class="water-bottles__quantity">
                            <label for="quantity">Choose Quantity</label>
                            <number-picker
                                v-bind:id="product.id" 
                                v-bind:value="quantities[product.id] || null"
                                :min="0" 
                                :max="10" 
                                :step="1" 
                                v-on:set-quantity="setQuantity"
                            >
                            </number-picker>
                        </div> <!-- .water-bottles__quantity -->
                    </div>
                </div> <!-- .water-bottles__options -->
                
                <button 
                    type="button" 
                    class="water-bottles__view-all-btn" 
                    v-on:click="enableViewAllModal()"
                >
                    See All Gallon Water Options
                </button>
                <br>
                
                <button 
                    type="button" 
                    class="water-bottles__widget-btn" 
                    v-on:click="enableQuantityCalculator()"
                >
                    How Much Do I Need?
                </button>
                
            </div>
            
            <div class="col-lg-4 coolers">
                <h3>Select Cooler</h3>
                
                <div class="coolers__options">
                    <template v-for="(c, index) in gallonWaterCoolers">
                        <div class="coolers__option" v-if="c.active">
                            <label v-bind:for="'cooler-' + index">
                                <img :src="c.image" alt="">
                                <span>{{ c.name }}</span>
                            </label>
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" v-model="cooler" v-bind:id="'cooler-' + index" v-bind:value="c" required>
                                <label class="custom-control-label" v-bind:for="'cooler-' + index"></label>
                            </div>
                        </div>
                    </template>
                </div> <!-- .coolers__options -->


                <div class="mt-2">
                    <label id="color">Select a Color</label>
                    <select name="color" id="color" v-model="coolerColor" class="form-select" required>
                        <option v-bind:value="color" v-for="color in colors">{{ color }}</option>
                    </select>
                </div>

            </div>
        </div> <!-- .row -->
        
        <div class="gallon-water__continue">
            <button type="button" class="btn btn-store btn-lg" v-on:click="addToCart()">Continue</button>
        </div>
        
        <!-- View All Modal -->
        <div class="view-all" tabindex="-1" role="dialog" v-show="viewAllModalEnabled">
            <div class="view-all__container" role="document">
                <div class="view-all__content">
                    <div class="view-all__header">
                        <h3 class="view-all__title">Additional Water Offerings</h3>
                        
                        <button type="button" class="close" aria-label="Close" v-on:click="disableViewAllModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="view-all__body">
                        <ul class="products">
                            <li v-for="product in gallonWaterProducts">
                                <div class="product__img">
                                    <img v-bind:src="product.image" v-bind:alt="product.name">
                                </div>
                                
                                <span class="product__name">{{ product.name }}</span>
                                <span class="product__size">{{ product.size }}</span>
                                <span class="product__price">${{ product.price }}/bottle</span>

                                <div class="product__quantity">
                                    <label for="quantity">Choose Quantity</label>
                                    <number-picker
                                        v-bind:id="product.id" 
                                        v-bind:value="quantities[product.id] || null"
                                        :min="0" 
                                        :max="10" 
                                        :step="1" 
                                        v-on:set-quantity="setQuantity"
                                    >
                                    </number-picker>
                                </div> <!-- .product__quantity -->
                            </li>
                        </ul>
                        
                        <div class="view-all__buttons">
                            <button type="button" class="btn btn-store" v-on:click="disableViewAllModal()">Add to Cart</button>
                        </div>
                    </div> <!-- .view-all__body -->
                </div>
            </div>
        </div> <!-- .view-all -->
        
        <!-- "How Much Do I Need?" widget -->
        <div class="widget" tabindex="-1" role="dialog" v-show="quantityCalculatorEnabled">
            <div class="widget__container" role="document">
                <div class="widget__content">
                    <div class="widget__header">
                        <h3 class="widget__title">How Much Do I Need?</h3>
                        
                        <button type="button" class="close" aria-label="Close" v-on:click="disableQuantityCalculator()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="widget__body">
                        <div class="row">
                            <div class="widget__col col-lg-6">
                                <label for="widget-num-people" class="d-block">How many people in your home or office?</label>
                                <number-picker
                                    id="widget-num-people" 
                                    :min="1" 
                                    :max="10" 
                                    :step="1" 
                                    v-on:set-quantity="setWidgetNumPeople"
                                >
                                </number-picker>
                            </div>
                            
                            <div class="widget__col col-lg-6">
                                <label for="widget-num-people" class="d-block">How many pets?</label>
                                <number-picker
                                    id="widget-num-pets" 
                                    :min="0" 
                                    :max="10" 
                                    :step="1" 
                                    v-on:set-quantity="setWidgetNumPets"
                                >
                                </number-picker>
                            </div>
                        </div> <!-- .row -->
                        
                        <div class="widget__result">
                            We recommend <span class="result__quantity">{{ widgetResult }}</span> 5-gallon water bottles per month
                        </div> <!-- .widget__result -->
                    </div> <!-- .widget__body -->
                </div>
            </div>
        </div> <!-- .widget -->
                    
    </div>
</template>

<script>
import store from '../../store.js'
import swal from 'sweetalert'
import NumberPicker from '../NumberPicker'

export default {
  data() {
    return {
      offerSelected: true,
      quantities: {},
      cooler: null,
      coolerColor: null,
      viewAllModalEnabled: false,
      quantityCalculatorEnabled: false,
      widgetNumPeople: 0,
      widgetNumPets: 0,
    }
  },
  components: {
    'number-picker': NumberPicker,
  },
  watch: {
    cooler() {
      if (this.colors) {
        this.coolerColor = this.colors[0]
      }
    }
  },
  computed: {
    pluginUrl() {
      return store.state.pluginUrl
    },
    product() {
      return store.getters.getDefaultGallonWater
    },
    colors() {
      if (this.cooler) {
        return this.cooler.colors
      }
      
      return []
    },
    offerIsAvailable() {
      return store.state.offers.length && ! store.getters.cartHasDiscount
    },
    offer() {
      if (store.state.offers.length) {
        return store.state.offers[0]
      }
    },
    offerName() {
      if (this.offer != undefined) {
        return this.offer.name
      }
    },
    widgetResult() {
      return Math.ceil(((this.widgetNumPeople * 3.5) + (this.widgetNumPets * 2.5)) / 5)
    },
    gallonWaterProducts() {
      return store.getters.getGallonWater
    },
    gallonWaterCoolers() {
      return store.state.gallonWaterCoolers
    }
  },
  mounted() {
    store.dispatch('setCurrentStep', 'products')
  },
  methods: {
    enableQuantityCalculator() {
      this.quantityCalculatorEnabled = true
    },
    disableQuantityCalculator() {
      this.quantityCalculatorEnabled = false
    },
    enableViewAllModal() {
      this.viewAllModalEnabled = true
    },
    disableViewAllModal() {
      this.viewAllModalEnabled = false
    },
    setQuantity(quantity, productId) {
      let currentQuantity = this.quantities[productId] || 0

      // Increase: min. is 3
      if (quantity > currentQuantity) {
        if (quantity > 0 && quantity < 3) {
          quantity = 3
        }
      }

      // Decrease
      if (quantity < currentQuantity) {
        if (quantity > 0 && quantity < 3) {
          quantity = 0
        }
      }

      this.quantities[productId] = quantity
    },
    setWidgetNumPeople(quantity) {
      this.widgetNumPeople = quantity
    },
    setWidgetNumPets(quantity) {
      this.widgetNumPets = quantity
    },
    addToCart() {
      let totalQuantity = 0;
      for (let productId in this.quantities) {
        totalQuantity += this.quantities[productId]
      }

      if (totalQuantity <= 0) {
        swal({
          //title: 'Whoops!',
          text: 'Please enter a quantity for at least one gallon water option.',
          icon: 'error',
        })
        return
      }

      if (this.cooler && ! this.coolerColor) {
        swal({
          //title: 'Whoops!',
          text: 'Please select a cooler color.',
          icon: 'error',
        })
        return
      }

      // Add to Cart
      this.addItemsToCart()
    },
    addItemsToCart() {

      // Offer
      if (this.offerSelected && this.offerIsAvailable) {
        store.dispatch('addOfferToCart', this.offer)
      }

      // Products
      let options = {
        type: 'gallon-water',
        cooler: this.cooler,
        coolerColor: this.coolerColor,
      }

      let quantity = null
      for (let productId in this.quantities) {
        quantity = this.quantities[productId]

        if (quantity > 0) {
          options['quantity'] = parseInt(quantity)

          store.dispatch('addToCart', {
            productId: productId,
            options: options,
          })
        }
      }

      // Go to Products
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      store.dispatch('goToProducts')
    }
  }
}
</script>
